import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import "./TransactionTable.scss";
import Check from "../../images/table_check.svg";
import Warningsign from "../../images/Warning.png";
import ComplianceModal from "../ComplianceModal/ComplianceModal";

function CustomerTable(props) {
  const theme = useTheme();
  const { page, onPageChange, pageNumbers } = props;

  const handlePageClick = (event, pageNumber) => {
    onPageChange(event, pageNumber);
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        ml: 2.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <IconButton
          onClick={(event) => handlePageClick(event, page - 1)}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <>
              <KeyboardArrowLeft />
              <span className="arrowLabelStyle">Previous</span>
            </>
          )}
        </IconButton>
      </div>
      <div>
        {pageNumbers.map((pageNumber, index) => {
          if (pageNumbers.length <= 5) {
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (
            index === 0 ||
            index === pageNumbers.length - 1 ||
            Math.abs(index - page) <= 1
          ) {
            return (
              <span
                key={pageNumber}
                className={`page-number ${
                  pageNumber === page ? "active-page" : ""
                }`}
                onClick={(event) => handlePageClick(event, pageNumber)}
              >
                {pageNumber + 1}
              </span>
            );
          } else if (index === 1 || index === pageNumbers.length - 2) {
            return (
              <span key={pageNumber} className="ellipsis">
                ...
              </span>
            );
          }
          return null;
        })}
      </div>
      <div>
        <IconButton
          onClick={(event) => handlePageClick(event, page + 1)}
          disabled={page === pageNumbers.length - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <>
              <span className="arrowLabelStyle">Next</span>
              <KeyboardArrowRight />
            </>
          )}
        </IconButton>
      </div>
    </Box>
  );
}

export default function TransactionTable({
  transactionAuditData,
  view,
  hideAudit,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [selectedData, setSelectedData] = useState();
  const [fullSelectedData, setfullSelectedData] = useState();

  const handleOpen = (data, fullData) => {
    setOpen(true);
    setSelectedData(data);
    setfullSelectedData(fullData);
  };
  const handleClose = () => setOpen(false);

  const pageCount = Math.ceil(transactionAuditData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  // This is for sorting for the table headers
  const handleSortClick = (column) => {
    if (sorting.column === column) {
      setSorting({
        column,
        direction: sorting.direction === "asc" ? "desc" : "asc",
      });
      transactionAuditData.sort((a, b) => {
        const valueA =
          column === "fee" || column === "amount"
            ? a[column]
            : a[column].toUpperCase();
        const valueB =
          column === "fee" || column === "amount"
            ? b[column]
            : b[column].toUpperCase();

        if (sorting.direction === "asc") {
          return column === "fee" || column === "amount"
            ? valueA - valueB
            : valueA.localeCompare(valueB);
        } else {
          return column === "fee" || column === "amount"
            ? valueB - valueA
            : valueB.localeCompare(valueA);
        }
      });
    } else {
      setSorting({ column, direction: "asc" });
      transactionAuditData.sort((a, b) => a.id - b.id);
    }
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    setPage(0);
  }, [transactionAuditData]);

  const getRulesIcon = (amlRules) => {
    var rulesArray = amlRules.split(",");

    return rulesArray[0];
  };

  return (
    <>
      <>
        <ComplianceModal
          open={open}
          handleClose={handleClose}
          selectedData={selectedData}
          setSelectedData={(data) => setSelectedData(data)}
          fullSelectedData={fullSelectedData}
          setfullSelectedData={(data) => setfullSelectedData(data)}
          view={view}
        />
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table
            sx={{ minWidth: 500 }}
            aria-label="custom pagination table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Date Sent</p>
                    {sorting.column === "date" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Sender</p>
                    {sorting.column === "receivingAddress" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">DOB</p>
                    {sorting.column === "type" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>

                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Sender Country</p>
                    {sorting.column === "status" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Sender Currency</p>
                    {sorting.column === "transactionId" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Sender Agent</p>
                    {sorting.column === "userName" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Recipient</p>
                    {sorting.column === "fee" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">
                      Recipient Country
                    </p>
                    {sorting.column === "amount" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Reference No.</p>
                    {sorting.column === "amount" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">
                      Recipient Occupation
                    </p>
                    {sorting.column === "amount" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Purpose</p>
                    {sorting.column === "amount" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                <TableCell align="left" className="transaction-table-headers">
                  <div className="header-cell-content">
                    <p className="transaction-table-headers">Amount</p>
                    {sorting.column === "amount" && (
                      <span className="sort-arrow">
                        {sorting.direction === "asc" ? "▲" : "▼"}
                      </span>
                    )}
                  </div>
                </TableCell>
                {hideAudit ? null : (
                  <TableCell align="left" className="transaction-table-headers">
                    <div className="header-cell-content">
                      <p className="transaction-table-headers">Audit</p>
                      {sorting.column === "amount" && (
                        <span className="sort-arrow">
                          {sorting.direction === "asc" ? "▲" : "▼"}
                        </span>
                      )}
                    </div>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {transactionAuditData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 150 }}
                    >
                      <p className="transaction-table-date">
                        {row.transactionaudit.datetime}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <div className="transaction-table-address-container">
                        <p className="transaction-table-address">
                          {row.transactionaudit.userid}
                        </p>
                      </div>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.BirthDate
                        }

                        {/* {
                            JSON.parse(
                              row.transactionaudit.sourcedata.replace(
                                /&quot;/g,
                                '"'
                              )
                            ).record.currentTransactionStatus
                          } */}
                      </p>
                    </TableCell>

                    <TableCell style={{ width: 110 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderCountry
                        }

                        {/* {row.status == "completed" ? (
                          <img src={Check} />
                        ) : row.status == "pending" ? (
                          <img src={Pending} />
                        ) : (
                          <img src={Cancelled} />
                        )} */}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 120 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderLocalCurrencyCode
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 120 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderAgentName
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 150 }} align="left">
                      <p className="transaction-table-date">
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverFirstName
                        }{" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverLastName
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 130 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.receiverAgentCountry
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 130 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.ReferenceNumber
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.recipientOccupation
                          //       ).record.relationshipWithReceiver
                        }
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {(() => {
                          const sourcedata = JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record;

                          const purposeOfTransaction =
                            sourcedata.purposeOfTransaction;

                          if (Array.isArray(purposeOfTransaction)) {
                            // If purposeOfTransaction is an array, join the values with a comma
                            return purposeOfTransaction.join(", ");
                          } else {
                            // If purposeOfTransaction is a single value, display it as is
                            return purposeOfTransaction;
                          }
                        })()}
                      </p>
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      <p className="transaction-table-date">
                        {" "}
                        {
                          JSON.parse(
                            row.transactionaudit.sourcedata.replace(
                              /&quot;/g,
                              '"'
                            )
                          ).record.senderLocalCurrencyAmount
                        }
                      </p>
                    </TableCell>
                    {hideAudit ? null : (
                      <TableCell style={{ width: 120 }} align="left">
                        <p className="transaction-table-date">
                          {getRulesIcon(row.transactionaudit.amlrule) != "0" ? (
                            <img
                              loading="lazy"
                              src={Warningsign}
                              className="pointer"
                              title={row.transactionaudit.amruledesc}
                              onClick={() =>
                                handleOpen(
                                  JSON.parse(
                                    row.transactionaudit.sourcedata.replace(
                                      /&quot;/g,
                                      '"',
                                      row.transactionaudit.userid
                                    )
                                  ).record,
                                  row.transactionaudit
                                )
                              }
                            />
                          ) : (
                            <img
                              loading="lazy"
                              className="pointer"
                              src={Check}
                              onClick={() =>
                                handleOpen(
                                  JSON.parse(
                                    row.transactionaudit.sourcedata.replace(
                                      /&quot;/g,
                                      '"',
                                      row.transactionaudit.userid
                                    )
                                  ).record,
                                  row.transactionaudit
                                )
                              }
                            />
                          )}
                        </p>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <CustomerTable
            page={page}
            onPageChange={handleChangePage}
            pageNumbers={pageNumbers}
          />
        </TableContainer>
      </>
    </>
  );
}
